export default "__VITE_ASSET__CpS0qITM__"